import { ActionTypes } from 'store/actions/seasonregistration';

const defaultSessionState = {
    registrationLink: null
};

function seasonRegistration (state = defaultSessionState, action) {
    switch (action.type) {
        case ActionTypes.SET_SEASON_REGISTRATION_LINK:
            return {
                ...action.session,
                registrationLink: action.data
            };

        default:
            return state;
    }
}

export default seasonRegistration;


// WEBPACK FOOTER //
// ./src/js/store/reducers/seasonregistration.js